const HelpCenter = () => {
  return (
    <section className='py-32 relative'>
      <div className='container mx-auto px-8 max-w-7xl'>
        <h2 className='section-title'>
          Центр помощи
        </h2>
        <p className='text-xl text-gray-600 dark:text-gray-400 mb-8'>
          Найдите ответы на свои вопросы и получите поддержку.
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          <div className='glass-card p-6 rounded-2xl'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>FAQ</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Ответы на часто задаваемые вопросы.
            </p>
          </div>
          <div className='glass-card p-6 rounded-2xl'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Поддержка 24/7</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Свяжитесь с нашей командой в любое время.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpCenter;
